// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-header{background:#fff;display:flex;flex:1 0 auto;height:60px;right:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
